import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b907558"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "loadingGrey",
  style: {"width":"100%","height":"2.5rem"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loadingGreyAnimation",
  style: {"width":"50%","height":"2.5rem"}
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(`width: 100%; padding: ${_ctx.padding}rem;`)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (i) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    }), 256))
  ], 4))
}